import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRICE, PRICE_BEFORE } from '../data/gymklar';
const recap = ['6 volumer', '5 bonuser', '240 sider', '1.–10. trinn'];
const reassurances = ['Direkte nedlasting', 'PDF klar til utskrift', '7 dager pengene-tilbake-garanti'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-seyes px-8 py-24 sm:px-14 sm:py-32" data-id="element-101" data-mp="15c2gpfrpmzv2">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-red-300 sm:left-8 lg:left-12" data-id="element-102" data-mp="1jbaj0hj66o3h" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-103" data-mp="1t2yc0mvdkd72">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-104" data-mp="1t253bgcuvdma">
          Kroppsøvingen din kan være <em className="text-red-700" data-id="element-105" data-mp="223mimwifvb9x">klar allerede i dag.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-900/75" data-id="element-106" data-mp="221jt0dl77k5q">
          I stedet for å lete etter aktiviteter, lage hver time selv og bruke søndagskvelden
          på planlegging, har du et ferdig system for hele skoleåret. Mer tid til det som
          virkelig betyr noe:
        </p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-slate-900 sm:text-3xl" data-id="element-107" data-mp="s6ihz1xtmuhu">
          Elevene dine. Timene dine. Livet ditt utenfor gymsalen.
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-900/70" data-id="element-108" data-mp="1246i67e74u7e">
          {recap.map(item => <li key={item} data-id="element-109" data-mp="1b3a0h95jh5ku">{item}</li>)}
        </ul>

        <p className="mt-8 text-base text-slate-900/60" data-id="element-110" data-mp="1b1ywb886lvt7">
          Før <s className="decoration-red-700 decoration-2" data-id="element-111" data-mp="1ftqfgxp0cz9b">{PRICE_BEFORE}</s>
        </p>
        <p className="mt-2 font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-112" data-mp="1kt3cgb9lfmpm">{PRICE}</p>
        <p className="mt-3 text-sm text-slate-900/70" data-id="element-113" data-mp="1pszei4yqd42j">Engangsbetaling – ingen abonnement.</p>

        <div className="mt-8 flex justify-center" data-id="element-114" data-mp="1ttjc19n7u9p7">
          <CtaButton className="w-full sm:w-auto" data-id="element-115" data-mp="1tuavxn7gaizn" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-1.5 text-sm text-slate-900/70" data-id="element-116" data-mp="3qvqkpyhbh8nh">
          {reassurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-117" data-mp="3lxf8jh3jum23">
              <CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-118" data-mp="3imuaepzqzct" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}